module.exports = __webpack_public_path__ + "img/UTKODA-9.bbb09297.jpg";